import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Loading from "@/components/Loading";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Pending from "@/pages/Pending";
import Dashboard from "@/pages/Dashboard";
import Training from "@/pages/Training";
import Resources from "@/pages/Resources";
import MyMos from "@/pages/MyMos";
import Leadership from "@/pages/Leadership";
import Media from "@/pages/Media";
import Profile from "@/pages/Profile";
import Recruits from "@/pages/Recruits";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Overview from "@/pages/Overview";
import VerifyEmail from "@/pages/VerifyEmail";

function Gate({ children, adminOnly }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.role) return <Navigate to="/onboarding" replace />;
  if (user.role !== "admin" && !isAdmin && !user.admin_approved) return <Navigate to="/pending" replace />;
  if (user.role === "admin" && !isAdmin && !user.admin_approved) return <Navigate to="/pending" replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }) {
  return <AppShell>{children}</AppShell>;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/pending" element={<Pending />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/overview" element={<Overview />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/about" element={<Overview />} />
      <Route path="/admin" element={<Gate adminOnly><Admin /></Gate>} />
      <Route path="/" element={<Gate><Shell><Dashboard /></Shell></Gate>} />
      <Route path="/training" element={<Gate><Shell><Training /></Shell></Gate>} />
      <Route path="/resources" element={<Gate><Shell><Resources /></Shell></Gate>} />
      <Route path="/mos" element={<Gate><Shell><MyMos /></Shell></Gate>} />
      <Route path="/leadership" element={<Gate><Shell><Leadership /></Shell></Gate>} />
      <Route path="/media" element={<Gate><Shell><Media /></Shell></Gate>} />
      <Route path="/profile" element={<Gate><Shell><Profile /></Shell></Gate>} />
      <Route path="/recruits" element={<Gate><Shell><Recruits /></Shell></Gate>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
